import { render, staticRenderFns } from "./OSearchHeaderComp.vue?vue&type=template&id=5b995cdf&"
import script from "./OSearchHeaderComp.vue?vue&type=script&lang=js&"
export * from "./OSearchHeaderComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports